<template>
  <v-row no-gutters justify="center" align="center">
    <div class="n-container-small pt-2">
      <v-row no-gutters justify="start" align="start">
        <div class="side-content-small ml-6">
          <v-row no-gutters align="center" class="content-header">
            <v-icon class="mr-3 pb-1">account_circle</v-icon>
            <div class="font-weight-bold">
              {{ me.firstname }} {{ me.lastname }}
            </div>
          </v-row>
          <div class="left-admin-nav">
            <ul>
              <li
                v-for="(tab, i) in tabs"
                :key="i"
                :class="{ active: tab.isActive }"
                @click="goToTab(tab)"
              >
                <v-icon class="float-right">keyboard_arrow_right</v-icon>
                <div>{{ tab.text }}</div>
              </li>
            </ul>
          </div>
        </div>
        <v-col align="start" class="pa-0 mx-6">
          <router-view />
        </v-col>
      </v-row>
    </div>
  </v-row>
</template>

<script>
import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState(`model/user`, [
      `me`,
    ]),
    rawTabs() {
      return [
        { text: `Mes infos`, path: `/my-account/infos` },
        { text: `Mon mot de passe`, path: `/my-account/password` },
        { text: `Notifications`, path: `/my-account/notifications` },
        // { text: `Google agenda`, path: `/my-account/google-calendar` },
      ];
    },
    tabs() {
      return this.rawTabs.map(tab => ({
        ...tab,
        isActive: this.$route.path === tab.path,
      }));
    },
  },

  methods: {
    goToFirstTabIfNeeded() {
      if (this.$route.name === `myAccount`) {
        this.$router.replace(this.tabs[0].path);
      }
    },
    goToTab(tab) {
      if (this.$route.path !== tab.path) {
        this.$router.push(tab.path);
      }
    },
  },

  watch: {
    '$route.path': function routePathChanged() {
      this.goToFirstTabIfNeeded();
    },
  },

  beforeMount() {
    this.goToFirstTabIfNeeded();
  },
};
</script>

<style lang="scss" scoped>
</style>
